var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"library-badge",class:_vm.badgeClass},[(_vm.icon)?_c(_vm.icon,{tag:"component"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.name)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }